import { View, Pressable, Image, Text, StyleSheet } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../constants/styles';

export function Header(props) {
  return (
    <View style={styles.header}>
      {!!props.onPressPrevious && (
        <Pressable
          onPress={props.onPressPrevious}
          style={{ paddingHorizontal: 25, paddingVertical: 25 }}
        >
          <Image
            style={[styles.arrowIcon]}
            source={require('../../../resources/arrow-right.png')}
            resizeMode="contain"
          />
        </Pressable>
      )}
      <Text style={styles.headerLabel}>{props.label}</Text>
      {!!props.onPressOpenMenu && (
        <Pressable
          onPress={props.onPressOpenMenu}
          style={{ paddingHorizontal: 25, paddingVertical: 25 }}
        >
          <Image
            style={[styles.menuIcon]}
            source={require('../../../resources/menu.png')}
            resizeMode="contain"
          />
        </Pressable>
      )}
    </View>
  );
}

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLOR.altContrast,
    alignItems: 'center',
  },
  innerContainer: {
    ...THEME.container,
    width: '100%',
    maxWidth: 450,
    overflow: 'hidden',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: COLOR.overlay,
    opacity: 0,
    pointerEvents: 'none',
  },
  header: {
    ...THEME.basicRow,
    height: 70,
    borderBottomWidth: 2,
    borderColor: 'rgb(241, 241, 241)',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
  sideNav: {
    zIndex: 1001,
    position: 'absolute',
    top: 70,
    bottom: 0,
    right: -300,
    width: 300,
    backgroundColor: 'white',
    overflow: 'hidden',
    borderLeftWidth: 2,
    borderColor: 'rgb(241, 241, 241)',
  },
  headerLabel: {
    flex: 1,
    ...FONT.semibold,
    color: 'black',
    fontSize: 12,
    textAlign: 'center',
  },
  sectionContainer: {
    zIndex: 1000,
  },
  sectionLabel: {
    ...FONT.regular,
    backgroundColor: COLOR.accent,
    color: COLOR.text,
    padding: 15,
  },
  section: {
    padding: 20,
  },
  questionLabel: {
    ...THEME.textRegular,
    fontSize: FONT_SIZE.regular,
    color: 'rgb(41, 42, 49)',
    paddingVertical: 13,
    lineHeight: 20,
  },
  questionLabelHorizontal: {
    flex: 1,
    ...FONT.medium,
  },
  subQuestionContainer: {
    paddingVertical: 15,
    padding: 25,
    paddingRight: 35,
    borderColor: 'rgb(209, 209, 209)',
    borderWidth: 1,
    borderBottomRightRadius: 20,
    borderBottomLeftRadius: 20,
  },
  arrowIcon: {
    width: 14,
    height: 26,
    transform: [{ rotate: '180deg' }],
    tintColor: COLOR.emphasis,
  },
  menuIcon: {
    width: 22,
    height: 22,
  },
  emailSentIcon: {
    width: 107,
    height: 58,
  },
  brandingContainer: {
    justifyContent: 'center',
    paddingBottom: 40,
    paddingTop: 80,
  },
  branding: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  brandingTextContainer: {
    flexDirection: 'row',
    marginLeft: 14,
  },
  brandingText: {
    ...FONT.semibold,
    fontSize: 16,
    color: COLOR.darkTheme.text,
    marginLeft: 4,
  },
  brandingSubText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.xlarge,
    color: COLOR.emphasis,
    textAlign: 'center',
    marginTop: 20,
  },
  brandingImage: {
    width: 66,
    height: 66,
  },
  successImage: {
    width: 80,
    height: 80,
  },
  orDivider: {
    ...THEME.basicRow,
  },
  orDividerLeft: {
    flex: 1,
    backgroundColor: 'black',
    height: 2,
  },
  orDividerRight: {
    flex: 1,
    backgroundColor: 'black',
    height: 2,
  },
  orText: {
    ...FONT.medium,
    color: 'black',
    fontSize: 16,
    marginHorizontal: 25,
  },
});
